import { TTypeOfCodec } from "../../../shared/src/codecs/codec";
import { formIO, TFormIOCodec } from "../../../shared/src/codecs/types/formIO";
import { required, TRequiredCodec } from "../../../shared/src/codecs/types/required";
import { uuid, TUuidCodec } from "../../../shared/src/codecs/types/uuid";
import { string } from "../../../shared/src/codecs/types/string";
import { integer } from "../../../shared/src/codecs/types/integer";
import { TAnyUnionCodec, union } from "../../../shared/src/codecs/types/union";
import { nullCodec } from "../../../shared/src/codecs/types/nullCodec";
import { longString } from "../../../shared/src/codecs/types/longString";
import { positiveDecimal } from "../../../shared/src/codecs/types/positiveDecimal";
import { array, TAnyArrayCodec } from "../../../shared/src/codecs/types/array";

type TListingValuationInputCodec = TRequiredCodec<{
    listing_id: TUuidCodec;
}>;

type TListingValuationOutputCodec = TRequiredCodec<{
    val_status: TAnyUnionCodec;
    val_recommended_marketing_price: TAnyUnionCodec;
    val_property_type: TAnyUnionCodec;
    val_bedrooms: TAnyUnionCodec;
    val_bathrooms: TAnyUnionCodec;
    val_floor_area_sqm: TAnyUnionCodec;
    val_tenure: TAnyUnionCodec;
    val_receptions: TAnyUnionCodec;
    val_year_built: TAnyUnionCodec;
    val_heating_type: TAnyArrayCodec;
    val_glazed_type: TAnyArrayCodec;
    val_parking_type: TAnyArrayCodec;
    val_outdoor_space: TAnyArrayCodec;
    val_storey_count: TAnyUnionCodec;
    val_rental_value_pcm: TAnyUnionCodec;
    val_renovation_cost: TAnyUnionCodec;
    val_renovated_value: TAnyUnionCodec;
    val_description_html: TAnyUnionCodec;
    val_summary: TAnyUnionCodec;
    val_advantages: TAnyArrayCodec;
    val_disadvantages: TAnyArrayCodec;
    val_condition: TAnyUnionCodec;
    val_occupancy: TAnyUnionCodec;
    val_reason_for_sale: TAnyUnionCodec;
    val_conveyancer_org: TAnyUnionCodec;
    val_conveyancer_name: TAnyUnionCodec;
    val_conveyancer_email: TAnyUnionCodec;
    val_conveyancer_phone: TAnyUnionCodec;
    val_conveyancer_address: TAnyUnionCodec;
}>;

export const ListingValuationFormIO: TFormIOCodec<
    TListingValuationInputCodec,
    TListingValuationOutputCodec
> = formIO(
    required({ listing_id: uuid() }),
    required({
        val_status: union([nullCodec(), string()]),
        val_recommended_marketing_price: union([nullCodec(), integer()]),
        val_property_type: union([nullCodec(), string()]),
        val_bedrooms: union([nullCodec(), integer()]),
        val_bathrooms: union([nullCodec(), integer()]),
        val_floor_area_sqm: union([nullCodec(), positiveDecimal()]),
        val_tenure: union([nullCodec(), string()]),
        val_receptions: union([nullCodec(), integer()]),
        val_year_built: union([nullCodec(), integer()]),
        val_heating_type: array(string()),
        val_glazed_type: array(string()),
        val_parking_type: array(string()),
        val_outdoor_space: array(string()),
        val_storey_count: union([nullCodec(), integer()]),
        val_rental_value_pcm: union([nullCodec(), integer()]),
        val_renovation_cost: union([nullCodec(), integer()]),
        val_renovated_value: union([nullCodec(), integer()]),
        val_description_html: union([nullCodec(), longString()]),
        val_summary: union([nullCodec(), longString()]),
        val_advantages: array(string()),
        val_disadvantages: array(string()),
        val_condition: union([nullCodec(), string()]),
        val_occupancy: union([nullCodec(), string()]),
        val_reason_for_sale: union([nullCodec(), string()]),
        val_conveyancer_org: union([nullCodec(), string()]),
        val_conveyancer_name: union([nullCodec(), string()]),
        val_conveyancer_email: union([nullCodec(), string()]),
        val_conveyancer_phone: union([nullCodec(), string()]),
        val_conveyancer_address: union([nullCodec(), longString()]),
    }),
);

export type TListingValuationFormIOCodec = typeof ListingValuationFormIO;
export type TListingValuationFormIO = TTypeOfCodec<TListingValuationFormIOCodec>;
